import { delay } from 'redux-saga/effects';
import { all, call, put, race, take } from 'redux-saga/effects';
import { Credentials } from 'types';
import { loginFailure, loginSuccess } from 'actions/shellActions';
import { login, logout } from 'api';
import { handleErrorSaga } from 'sagas/app/handleError';

export function* loginRequestWatcher() {
    while (true) {
        const { redundantLogout, request } = yield race({
            redundantLogout: take('LOGOUT'), // Ignore logout requests if user isn't logged in (e.g. when user is booted out of a multiview)
            request: take('LOGIN_REQUEST'), // User clicks the Login button on the Login form
            success: take('LOGIN_SUCCESS'), // App attempts (and succeeds) with an auto-login during initialization
        });
        
        if (redundantLogout) {
            continue;
        }

        if (request) {
            const loggedIn = yield call(loginSaga, request.payload);
            if (!loggedIn) {
                continue;
            }
        }

        yield take('LOGOUT');
        yield delay(1000); // Give the video cells time to disconnect
        yield call(tryLogoutSaga);
    }
}

export function* loginSaga(credentials: Credentials) {
    // Cause the login attempt to take at least 200ms so animations have time to run / be seen
    const [ responseOrError ] = yield all([
        call(tryLoginSaga, credentials),
        delay(200),
    ]);

    if (typeof responseOrError.stack === 'undefined') {
        yield put(loginSuccess(responseOrError));
        return true;
    }
    else {
        yield call(handleErrorSaga, responseOrError, loginFailure);
        return false;
    }
}

export function* tryLoginSaga(credentials: Credentials) {
    try {
        return yield call(login, credentials);
    }
    catch (err) {
        // return instead of throw so we don't break the 'all()' effect
        return err;
    }
}

export function* tryLogoutSaga() {
    try {
        yield call(logout);
    }
    catch (err) {
        console.error(err);
    }
}



// WEBPACK FOOTER //
// ./src/sagas/shell/loginSaga.ts